import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { getGridStringOperators } from "@mui/x-data-grid";
import { useEffect, useState, useContext, useCallback } from "react";
import { HiTemplate } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import NodataImg from "../../assets/images/noData.png";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useNavigate } from "react-router-dom";
import { resetCategory } from "../../store/categoryDetails/categoryDetail";
import { categoryApi } from "../../store/categoryDetails/categoryList";
import DeleteCategory from "./categoryDelete";
import { ThemeContext } from '../../context/ThemeContext';
import CustomGridToolbar from "../../components/CustomGridToolbar";
import apiRoutes from "../../store/apiConfigs";
import BackdropUI from "../../ui/Backdrop";
import DataGridComponent from "../../components/DataGridComponent";
export default function CategoryList() {
  const categories = useSelector((state) => state?.categories);
  const { result, loading, total } = categories;
  const [deleteId, setDeleteId] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedRow, setSelectedRow] = useState([]);
  const [notSelectedProductModel, setNotSelectedProductModel] = useState(false);
  const { paginationModel, setPaginationModel } = useContext(ThemeContext)
  const [isDownload, setIsDownload] = useState(false)
  const [queryOptions, setQueryOptions] = useState({});

  const onFilterChange = useCallback((filterModel) => {
    setQueryOptions({ filterModel: { ...filterModel } });
  }, []);
  const handleSortModelChange = useCallback((sortModel) => {
    setQueryOptions({ sortModel: [...sortModel] });
  }, []);
  const handleNavigation = async (id) => {
    navigate(`/edit-category/${id}`);
  };
  const columns = [
    {
      field: "id",
      headerName: "Category Id",
      width: 100,
      filterable: true,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === 'equals' | operator.value === 'contains',
      ),
      sortable: false,
    },
    {
      field: "title",
      headerName: "Category Name",
      width: 400,
      filterable: false,
      sortable: false,
    },
    {
      field: "card_bg_color",
      headerName: "Category Colour",
      width: 200,
      filterable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Stack
              sx={{ background: params.row.card_bg_color, height: 40, width: 80, borderRadius: 2 }} >
              {params.row.card_bg_color}
            </Stack>
          </>
        )
      }

    },
    {
      field: "icon",
      headerName: "Category Icon",
      width: 180,
      filterable: false,
      sortable: false,
      renderCell: (params) => {
        const icon =
          typeof params.row.icon === "string"
            ? params.row.icon.trim()
            : params.row.icon;

        if (!icon) {
          return "—";
        }

        return (
          <Box
            component="img"
            src={icon}
            alt={`${params.row.title || "Category"} icon`}
            sx={{ width: 40, height: 40, objectFit: "contain" }}
            onError={(event) => {
              event.currentTarget.style.visibility = "hidden";
            }}
          />
        );
      },
    },
    {
      field: "update_category",
      headerName: "Update Category",
      width: 150,
      disableExport: true,
      filterable: false,
      sortable: false,
      renderCell: (row) => (
        <>
          <Button
            color="info"
            endIcon={<EditIcon />}
            label="Available" variant="outlined"
            onClick={() => handleNavigation(row.id)}
          >
            Edit
          </Button>
        </>
      ),
    },
    {
      field: "delete_category",
      headerName: "Delete Category",
      width: 150,
      disableExport: true,
      filterable: false,
      sortable: false,
      renderCell: (row) => (
        <>
          <Button
            endIcon={<DeleteOutlineIcon />}
            color="error"
            variant="outlined"
            style={{ marginLeft: "5px" }}
            onClick={() => {
              setNotSelectedProductModel(true)
              setDeleteId(row.id)
            }}
          >
            Delete
          </Button>
        </>
      ),
    },


  ];

  const addToCartHandler = async () => {

    navigate("/add-category")
  };

  const backToCatHandler = () => {
    navigate("/category");
  };

  useEffect(() => {
    const filterModel = queryOptions?.filterModel;
    const items = filterModel?.items;
    const firstItem = items && items.length > 0 ? items[0] : {};
    const quickFilterValues = filterModel?.quickFilterValues;

    const query = {
      page: paginationModel?.page + 1,
      page_size: paginationModel?.pageSize,
      field: firstItem.field || '',
      operator: firstItem.operator || (quickFilterValues && "contains") || '',
      value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
    };
    dispatch(categoryApi(query));
    dispatch(resetCategory());
  }, [dispatch, paginationModel, queryOptions]);

  const getRowSpacing = useCallback((params) => {
    return {
      top: params.isFirstVisible ? 0 : 5,
      bottom: params.isLastVisible ? 0 : 5,
    };
  }, []);
  return (
    <>
      <Appbar />
      <Drawer />
      <Body>


        <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
          <HiTemplate size={30} />
          <Typography>Category List</Typography>
        </Stack>

        <Stack sx={{ my: 2 }} justifyContent="space-between" direction="row">

          <Stack direction="row" spacing={1}>

            <Button
              onClick={addToCartHandler}
              variant="contained"

            >
              Add New Category
            </Button>
          </Stack>
        </Stack>

        <Paper elevation={0}>
          <DataGridComponent
            loading={loading}
            rowCount={total}
            pageSize={paginationModel?.pageSize}
            onPageSizeChange={(newPageSize) => {
              setPaginationModel({
                ...paginationModel,
                pageSize: newPageSize,
              })
            }}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            sx={{
                    height: 500 
                }}
            getRowId={(row) => row.id}
            rows={result || []}
            getRowSpacing={getRowSpacing}
            columns={columns}
            onSortModelChange={handleSortModelChange}
            onFilterModelChange={onFilterChange}
            slots={{
              noRowsOverlay: () => (
                <Box className="noData">
                  <img src={NodataImg} alt="no data found" />
                </Box>
              ),
              toolbar: (props) =>
                (CustomGridToolbar({ ...props, moduleType: "categoryList", queryOptions: queryOptions, paginationModel: paginationModel, isDownload: isDownload, setIsDownload: setIsDownload, apiUrl: apiRoutes.categoryList })),
            }}
            slotProps={{
loadingOverlay: {
      variant: 'linear-progress',
      noRowsVariant: 'linear-progress',
    },
              toolbar: {
                showQuickFilter: true,
              },
            }}
          />
        </Paper>

      </Body>

      <DeleteCategory
        open={notSelectedProductModel}
        setOpen={setNotSelectedProductModel}
        setSelectedRow={setSelectedRow}
        id={deleteId}
      />
      <BackdropUI open={isDownload} />

    </>
  );
}
